import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, Signal, ViewContainerRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SideNavComponent } from '@components/shared/side-nav/side-nav.component';
import { ChatBubble } from '@division-25/chat-bubble';
import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';
import { IconSanitizerService, ModalService, SnackbarNotificationsContainerComponent } from 'ngx-lib';
import { HeaderComponent } from './components/header/header.component';
import { LoadingSpinnerComponent } from './components/shared/loading-spinner/loading-spinner.component';
import { IUser } from './interfaces/user.interface';
import { AuthService } from './services/auth.service';
import { CaddieChatConfigurationService } from './services/caddie-chat-configuration.service';
import { LoadingService } from './services/loading.service';
import { PostHogService } from './services/posthog.service';
import { RouterStateService } from './services/router-state.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        LoadingSpinnerComponent,
        HeaderComponent,
        SideNavComponent,
        SnackbarNotificationsContainerComponent,
        ChatBubble
    ]
})
export class AppComponent implements OnInit {
    isLoggedIn: Signal<boolean>;
    user: Signal<IUser | undefined>;
    isLoading: Signal<boolean>;
    fade: Signal<boolean>;
    loadingCaption: Signal<string | undefined>;
    currentUrl: Signal<string>;
    caddieChatUrl: string;
    chatBubbleVisible: Signal<boolean>;

    private readonly modalService: ModalService = inject(ModalService);
    private readonly viewContainer: ViewContainerRef = inject(ViewContainerRef);
    private readonly iconSanitizer: IconSanitizerService = inject(IconSanitizerService);
    private readonly authService: AuthService = inject(AuthService);
    private readonly loadingService: LoadingService = inject(LoadingService);
    private readonly routerStateService: RouterStateService = inject(RouterStateService);
    private readonly posthogService: PostHogService = inject(PostHogService);
    private readonly caddieChatConfiguration = inject(CaddieChatConfigurationService);

    constructor() {
        this.isLoggedIn = this.authService.isLoggedIn;
        this.user = this.authService.user;
        this.isLoading = this.loadingService.isLoading;
        this.fade = this.loadingService.fade;
        this.loadingCaption = this.loadingService.loadingMessage;
        this.currentUrl = this.routerStateService.currentBaseUrl;
        this.caddieChatUrl = this.caddieChatConfiguration.url;
        this.chatBubbleVisible = computed(
            () => this.caddieChatConfiguration.available && this.authService.hasCaddieAccess()
        );
        this.modalService.setViewContainer(this.viewContainer);
        ModuleRegistry.registerModules([AllEnterpriseModule]);
    }

    ngOnInit(): void {
        this.iconSanitizer.initializeIcons();
        this.posthogService.init();
    }
}
